import React, {useState} from 'react';
import {
    Accordion,
    AccordionDetails, AccordionGroup,
    AccordionSummary,
    Avatar,
    Box,
    Grid,
    IconButton,
    Menu,
    Sheet,
    Stack
} from '@mui/joy';
import Skill from "./Skill";
import {Add, Check, Circle, ExpandMore, Minimize} from "@mui/icons-material";
import {EducationModel} from "../model/education";
import {ExperienceModel} from "../model/experience";
import {SkillModel} from "../model/skill";
import {ServiceModel} from "../model/service";
import Typography from "@mui/joy/Typography";

function SkillGroup({name, skills}: { name: string, skills: Array<SkillModel> }) {

    const [expanded, setExpanded] = useState<boolean>(Array.from(skills).pop()!!.orderNumber <= 3);

    return (
        <Accordion
            expanded={expanded}
            onChange={(event, expanded) => {
                setExpanded(expanded);
            }}
        >
            <AccordionSummary
                indicator={expanded ? <Minimize/> : <Add/>}
            >
                <Typography sx={{paddingY: 1}} level="title-lg">{name}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Sheet sx={{borderRadius: 8}} variant='plain'>
                    <Grid container spacing={1}>
                        {
                            skills.map(value => (
                                <Grid key={value.title.concat('-' + value.category)} xs={3} sm={3} md={2} xl={2}>
                                    <Skill skill={value}/>
                                </Grid>
                            ))
                        }
                    </Grid>
                </Sheet>
            </AccordionDetails>
        </Accordion>
    );
}

export default SkillGroup;